export { default as GdaCentersKpiPanel } from "./GdaCentersKpiPanel.vue";
export * from "./config";
